import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faAirConditioner,
	faArrowLeftLong,
	faArrowRightLong,
	faBars,
	faBath,
	faBed,
	faBedFront,
	faBenchTree,
	faBicycle,
	faBottleWater,
	faBuildingColumns,
	faCalendarDays,
	faChampagneGlass,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronDown,
	faChevronUp,
	faCircleCheck,
	faCocktail,
	faCoffee,
	faCoffeePot,
	faCouch,
	faCroissant,
	faEnvelope,
	faGift,
	faGlobe,
	faGolfFlagHole,
	faHotTubPerson,
	faJugBottle,
	faLink,
	faMartiniGlass,
	faMasksTheater,
	faMicrophone,
	faMugHot,
	faMusic,
	faPersonHiking,
	faPersonSkiing,
	faPhone,
	faRefrigerator,
	faShower,
	faSnooze,
	faSpa,
	faSparkles,
	faStore,
	faTimes,
	faTree,
	faTv,
	faUtensils,
	faVault,
	faWater,
	faWifi,
	faWind,
	faWindowFrameOpen,
	faWineGlass,
} from '@fortawesome/pro-light-svg-icons';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import {
	faCheck,
	faStar,
	faQuoteLeft,
	faStarHalf,
	faPlay,
	faSearch,
	faChevronDown as fasChevronDown,
	faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import {
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTwitter,
	faTiktok,
	faWhatsapp,
	faYoutube,
	faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faAirConditioner,
	faArrowLeftLong,
	faArrowRightLong,
	faBars,
	faBath,
	faBed,
	faBedFront,
	faBenchTree,
	faBicycle,
	faBottleWater,
	faBuildingColumns,
	faCalendarDays,
	faChampagneGlass,
	faCheck,
	faChevronCircleLeft,
	faChevronCircleRight,
	faChevronDown,
	faChevronUp,
	faCircleCheck,
	faCocktail,
	faCoffee,
	faCoffeePot,
	faCouch,
	faCroissant,
	faEnvelope,
	faFacebook,
	faGift,
	faGlobe,
	faGolfFlagHole,
	faHotTubPerson,
	faInstagram,
	faJugBottle,
	faLink,
	faLinkedin,
	faLocationDot,
	faMartiniGlass,
	faMasksTheater,
	faMicrophone,
	faMugHot,
	faMusic,
	faPersonHiking,
	faPersonSkiing,
	faPhone,
	faPinterest,
	faPlay,
	faQuoteLeft,
	faRefrigerator,
	faSearch,
	faShower,
	faSnooze,
	faSoundcloud,
	faSpa,
	faSparkles,
	faSpotify,
	faStar,
	faStarHalf,
	faStore,
	faTiktok,
	faTimes,
	faTree,
	faTv,
	faTwitter,
	faUtensils,
	faVault,
	faWater,
	faWhatsapp,
	faWifi,
	faWind,
	faWindowFrameOpen,
	faWineGlass,
	faXTwitter,
	faXmark,
	faYoutube,
	fasChevronDown,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
